import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { loadNotifications } from '../actions';



class NotificationList extends Component {
  componentWillReceiveProps(nextProps) {
  }

  componentWillMount() {
    this.props.loadNotifications();
  }

  render() {
    const { notifications } = this.props;
    let notificationList = '';

    notificationList = notifications.map(item => {
      let readLabel = '(unread)';
      if(item.read) {
        readLabel = '';
      }
      return <li className="notifications-listItem">
        <Link to={`/notifications/${item.id}`} className="notifications-listItemAnchor">
          <div className="notifications-listItemTimestamp">{item.timeago} <span className="notification-readLabel">{readLabel}</span></div>
          <div className="notifications-listItemTitle">{item.title}</div>
        </Link>
      </li>;
    });

    if(notificationList.length == 0) {
      notificationList = <li className="notifications-listItem ">
        <Link to="#" className="notifications-listItemAnchor zero-notifications ">
        <div className="notifications-listItemTitle">You have no notifications.</div>
        </Link>
      </li>;
    }

    return <div className="notifications-inner">
      <div className="content-wrapper">
        <Link to="/notifications" className="notifications-pageTitle">Notification</Link>
        <ul className="notifications-list">
          {notificationList}
        </ul>
      </div>
    </div>;
  }
}


function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    loadNotifications
  }
)(NotificationList);



// WEBPACK FOOTER //
// ./src/containers/NotificationList.jsx